<template>
  <section id="forgot-password-code-section" class="section-scc-portal container">
    <b-alert
        class="message-banner"
        :show="messages.showMessage"
        :variant="messages.variant"
        dismissible
        @dismissed="messages.showMessage=false"
    >
      <span class="span-login-page">
        {{ messages.message }}
      </span>
    </b-alert>
    <form
        @submit.prevent="actionResetPassword"
        id="form-forgot-password-portal-scc"
        :model="forgotInformation"
    >
      <p class="p-section">Please provide following details in order to reset your password.</p>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="email-forgot-password">Email:</label>
          <input
              type="email"
              class="form-control input-form-css"
              :class="{'errorInput':objInvalid.invalidLogin}"
              id="email-forgot-password"
              aria-describedby="emailHelp"
              v-model.trim="forgotInformation.email"
          >
          <small id="emailHelp" class="form-text text-muted">Required field.</small>
        </div>
        <div class="container-input-form container-input-form-left col-sm">
        </div>
      </div>
      <div class="row container-item-form" style="text-align: center">
        <button
            type="submit"
            class="button-section btn"
        >
          RESET PASSWORD
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: "ldForgotPassword",
  data(){
    return{
      messages:{
        showMessage: false,
        messageFailSendEmail: false,
        variant: '',
        message: '',
      },
      forgotInformation: {
        email: '',
        requestPassword: '',
      },
      objInvalid: {
        invalidEmail: false,
      },
    }
  },
  methods:{
    async actionResetPassword (){

      if (!this.forgotInformation.email) {
        this.messages.message = 'The Email field is required.';
        this.messages.showMessage = true;
        this.messages.variant = 'danger';
        return;
      }

      const dataForgotPassword = {
        email_account: this.$store.getters["communication/emailSettings"].emailUserId,
        sendTo: this.forgotInformation.email
      }

      this.$root.$emit("showSpinner");
      const resForgotPassword = await this.$store.dispatch('auth/SET_forgotPassword', dataForgotPassword)
      this.$root.$emit("hideSpinner");

      if(!resForgotPassword.result.result){
        this.messages.message = resForgotPassword.result.message
        this.messages.showMessage = true
        this.messages.variant = 'danger'
      } else {
        this.messages.message = 'A new password has been sent to your email.'
        this.messages.showMessage = true
        this.messages.variant = 'success'
        setTimeout(this.$router.push({name: 'loginDonor'}), 3000);
      }
    }
  },
}
</script>

<style scoped>
  .span-login-page{
    white-space: pre-line
  }
</style>
